import { z } from "zod";
import { ERROR_CODES } from "./codes.js";
const ErrorCodeSchema = z.enum(ERROR_CODES);
export const FieldErrorSchema = z.object({
    code: z.string(),
    message: z.string(),
});
export const ErrorEnvelopeSchema = z.object({
    error: z.object({
        code: ErrorCodeSchema,
        message: z.string(),
        fields: z.record(z.string(), FieldErrorSchema).nullable(),
        requestId: z.string(),
        documentation: z.string().url(),
        retryable: z.boolean(),
        details: z.unknown().nullable(),
    }),
});
//# sourceMappingURL=envelope.js.map